import { useState } from 'react';

import { Button, type FormAsyncComboboxProps } from '@/_components';
import { phoneNumberIncludeKey } from '@/_containers';
import type { ContactQuerySchema } from '@/_pages/contacts/shared';
import { AsyncContactWithAllDetailsSelector } from '@/_pages/contacts/shared';
import { useQuickAddMenuContext } from '@/_providers/quick-add-provider/use-quick-add-menu-context';

type ContactSelectProps = {
  isEditable?: boolean;
  onChange: FormAsyncComboboxProps<ContactQuerySchema>['onValueChange'];
  autoFocus?: boolean;
};

export const ContactSelect = ({ isEditable = false, onChange, autoFocus = false }: ContactSelectProps) => {
  const [selectedContact, setSelectedContact] = useState<ContactQuerySchema | null>(null);
  const { showModal } = useQuickAddMenuContext<'/contacts/new'>();

  const handleChange = (item: ContactQuerySchema) => {
    setSelectedContact(item);
    onChange?.(item, { action: 'select-option', option: item });
  };

  const handleValueChange = (item: ContactQuerySchema | null) => {
    setSelectedContact(item);
    onChange?.(item, { action: 'select-option', option: item || undefined });
  };

  return (
    <div className="relative col-span-12 flex items-center justify-between">
      <AsyncContactWithAllDetailsSelector
        formItemClassName="w-full"
        label="Contact"
        value={selectedContact}
        onValueChange={handleValueChange}
        apiParams={{ include: `${phoneNumberIncludeKey()}` }}
        disabled={!isEditable}
        autoFocus={autoFocus}
      />

      {isEditable && (
        <div className="absolute -top-2.5 right-0">
          <Button
            size="xs"
            as="contained"
            className="px-2 py-0.5 text-[10px]"
            onClick={() => showModal('/contacts/new', handleChange)}
          >
            Add
          </Button>
        </div>
      )}
    </div>
  );
};
